var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49984 21.3332C8.96007 21.3332 9.33317 20.9601 9.33317 20.4998C9.33317 20.0396 8.96007 19.6665 8.49984 19.6665C8.0396 19.6665 7.6665 20.0396 7.6665 20.4998C7.6665 20.9601 8.0396 21.3332 8.49984 21.3332Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6668 21.3332C18.1271 21.3332 18.5002 20.9601 18.5002 20.4998C18.5002 20.0396 18.1271 19.6665 17.6668 19.6665C17.2066 19.6665 16.8335 20.0396 16.8335 20.4998C16.8335 20.9601 17.2066 21.3332 17.6668 21.3332Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 3.8335H5.16683L7.40016 14.9918C7.47637 15.3755 7.68509 15.7201 7.98978 15.9654C8.29448 16.2107 8.67574 16.341 9.06683 16.3335H17.1668C17.5579 16.341 17.9392 16.2107 18.2439 15.9654C18.5486 15.7201 18.7573 15.3755 18.8335 14.9918L20.1668 8.00016H6.00016",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.0a62e91b02fb9d0772e18696b52c551e.svg";
export { ForwardRef as ReactComponent };